<div class="eau-loader-holder" [class.eau-is-loader-shown]="showLoader">
    <div *ngIf="!showLoader" [@loaderHolderAnimation]>
        <ng-content></ng-content>
    </div>

    <eau-loader-spinner *ngIf="showLoader"></eau-loader-spinner>
</div>
